import { Component, OnDestroy, OnInit } from '@angular/core';
import { SitesBuilderLibComponent, Vr } from '@3ddv/ngx-sites-builder-lib';
import { Subscription } from 'rxjs';
import { ToolsService } from '../services/tools.service';
import { Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-sbeditor-tool-vr',
  templateUrl: './vr.component.html',
  styleUrls: ['./vr.component.scss']
})
export class VrComponent implements OnInit, OnDestroy {
  private subscriptions: Array<Subscription>;
  public tool: Vr;
  @Output() exportTool = new EventEmitter<Vr>();

  constructor(private toolsService: ToolsService) {
    this.subscriptions = [];
  }

  ngOnInit(): void {
    const tools$ = this.toolsService.getAsyncTools$().subscribe(res=>{
      if(res.vr){
        this.tool = JSON.parse(JSON.stringify(res.vr));
      }else{
        console.error("VR tool not found");
        return;
      }

    });
    this.subscriptions.push(tools$);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(o=>o.unsubscribe());
  }
  onSelect($event): void{
    this.exportTool.emit(this.tool);
  }
}
